// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__11WYW","insightsList":"newBusinessInsightsMenu_insightsList__2cYfn","active":"newBusinessInsightsMenu_active__3YU8y"};